import type { RouterProps } from 'wouter';
import { ExternalAccountDetailView } from 'components/pages/Integrations/ExternalAccountDetailView';
import { ExternalAccountsListView } from 'components/pages/Integrations/ExternalAccountsListView';
import { LinkDetailView } from 'components/pages/Integrations/LinkDetailView';
import { DecodedParamsRoute } from 'components/routing/DecodedParamsRoute';
import React, { Suspense } from 'react';
import { match, P } from 'ts-pattern';
import { Redirect, Route, Router, Switch, useLocation, useRoute } from 'wouter';

import { LoadingTable } from '@fragment/ui/src/components/LoadingTable/LoadingTable';

import { SettingsModalLayout } from '../SchemasV2/WorkspaceSettings/SettingsModalLayout';
import { IntegrationsMainView } from './IntegrationsMainView';

export const IntegrationsLoadingView = () => {
  const [, navigate] = useLocation();
  const [isLinkPage] = useRoute('/links/id/:linkId');
  const [, subpageParams] = useRoute('/links/id/:linkId/:rest*');
  const backPath = match([isLinkPage, subpageParams])
    .with([true, P._], () => '/')
    .with([false, P.nonNullable], ([, params]) => `/links/id/${params.linkId}`)
    .otherwise(() => undefined);
  return (
    <SettingsModalLayout
      title={<span className="text-main-500">Loading</span>}
      onBackButtonClick={
        backPath === undefined ? undefined : () => navigate(backPath)
      }
    >
      <LoadingTable rows={4} cols={2} fullWidth={false} textSize="inherit" />
    </SettingsModalLayout>
  );
};

export const IntegrationsDesigner = ({
  base,
  hook,
  matcher,
}: Partial<RouterProps>): ReturnType<typeof Router> => (
  <Router hook={hook} matcher={matcher} base={base} key={base}>
    <Suspense fallback={<IntegrationsLoadingView />}>
      <Switch>
        <DecodedParamsRoute path="/" component={IntegrationsMainView} />
        <DecodedParamsRoute
          path="/links/id/:linkId"
          component={ExternalAccountsListView}
        />
        <DecodedParamsRoute
          path="/links/id/:linkId/accounts/:accountId"
          component={ExternalAccountDetailView}
        />
        <DecodedParamsRoute
          path="/links/id/:linkId/details"
          component={LinkDetailView}
        />
        <Route>
          <Redirect href="/" replace />
        </Route>
      </Switch>
    </Suspense>
  </Router>
);
